const $ = require('jquery');

import { iti_config, phone_settings, safeInitIntlTelInput } from '../../intl_tel_input_config';
import DatePicker from '../../search_widget/date-picker';

document.addEventListener('DOMContentLoaded', function () {
  const iti = safeInitIntlTelInput('#fast_book_phone', iti_config);
  $('#fast_book_phone').change();

  const datepickerFormId = window.isMobileDevice ? 'datepicker_container' : 'fast_book_form';

  const fastBookDatePicker = new DatePicker(datepickerFormId, {
    dateRange: '#fast_book_date_range',
    dateStart: '#fast_book_date_start',
    dateEnd: '#fast_book_date_end',
    dateInput: '#fast_book_date_range',
  });

  fastBookDatePicker.init();

  $('#fast_book_date_range').on('mousedown', function (e) {
    e.preventDefault();
  });

  const $fastBookForm = $('#fast_book_form');

  if ($fastBookForm.length) {
    $fastBookForm.on('ajax:beforeSend', function (event) {
      if (!validatePhone(iti) || !validateName()) {
        event.preventDefault();
        return false;
      }
    });

    $fastBookForm.on('ajax:success', function (event, data) {
      const successText = data['working_hours']
        ? 'Менеджер свяжется с Вами в течение 15 минут'
        : 'Менеджер свяжется с Вами с 8.00 до 20.00 по московскому времени';
      $('#fast_book_success_info').text(successText);
      $('#fast_book_title').hide();
      $fastBookForm.hide();
      $('#fast_book_success').show();
    });
  }

  initApartmentPopupSelect();
  initApartmentSelect();
});

function initApartmentPopupSelect() {
  const $select = $('#apartment_select');
  const $popup = $('#fast_book_apartment_popup');

  if (!$select.length || !$popup.length) return;

  const $hiddenInput = $select.find('input[type="hidden"]');
  const $valueLabel = $select.find('.ui-select__value');
  const $nameInput = $('#apartment_name');

  $popup.find('.popup-select__option').on('click', function () {
    const $option = $(this);
    const value = $option.data('value');
    const name = $option.data('name');

    $hiddenInput.val(value).trigger('change');
    $valueLabel.html($option.html());
    $nameInput.val(name);

    $popup.find('.popup-select__option').removeClass('popup-select__option_selected');
    $option.addClass('popup-select__option_selected');

    $popup.find('.popup-close').trigger('click');
  });
}

function initApartmentSelect() {
  const $select = $('.apartment_select');
  if (!$select.length) return;

  const $nameInput = $('#apartment_name');

  $select.on('click', '.mtui-select__option', function () {
    $nameInput.val($(this).data('name'));
  });
}

function validatePhone(iti) {
  let res = true;

  const $input = $('#fast_book_phone');
  const expr = phone_settings[iti.getSelectedCountryData().iso2]['validator'];

  if ($input.val().trim() === '' || !expr.test($input.val().trim())) {
    $input.addClass('input-error');
    res = false;
  } else {
    $input.removeClass('input-error');
    res = true;
  }

  return res;
}

function validateName() {
  let res = true;

  const $input = $('#fast_book_name');

  if ($input.val().trim() === '') {
    $input.addClass('input-error');
    res = false;
  } else {
    $input.removeClass('input-error');
    res = true;
  }
  return res;
}
